<section *ngIf="!!post" class="max-w-[600px] mx-auto relative" [ngClass]="{'post--embed': hasEmbed}">
  <header
    class="top-header sticky top-0 z-50 h-[64px] pl-[16px] pr-[16px] flex items-center"
    [class.justify-between]="hasEmbed"
    [class.justify-end]="!hasEmbed"
  >
    @if (hasEmbed) {
    <div class="flex items-center gap-x-[12px] min-w-0">
      <img
        *ngIf="coverUrl"
        [src]="coverUrl"
        [alt]="post?.title"
        class="post__embed-thumbnail w-[40px] h-[40px] rounded-[8px] object-cover shrink-0"
        width="40"
        height="40"
      />
      <h1 class="post__embed-title truncate min-w-0">{{ post?.title }}</h1>
    </div>
    }
    <a
      [routerLink]="`/blog/${post.category?.slug}/${post.tag?.slug}`"
      aria-label="Close article"
      class="w-[48px] h-[48px] bg-white/75 border-[2px] border-white rounded-full flex items-center justify-center shrink-0"
    >
      <svg
        class="w-6 h-6"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18 17.94 6M18 18 6.06 6"
        />
      </svg>
    </a>
  </header>
  <div [class.pt-[24px]]="!hasEmbed">
    @if (!hasEmbed) {
    <app-post-card-component
      [post]="post"
      [small]="true"
      [rotate]="true"
      class="flex justify-center"
    ></app-post-card-component>
    }
    <app-post-content-section
      [postContent]="post"
      [hideActions]="hasEmbed"
      [hideTitle]="hasEmbed"
      [hideRelevantPosts]="hasEmbed"
      [fullscreen]="hasEmbed"
    ></app-post-content-section>
  </div>
</section>
